var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobile-number c-pointer g-cc--text",on:{"click":_vm.toggle}},[_c('v-fade-transition',[(_vm.show)?_c('small',[_vm._v(_vm._s(_vm.number))]):_c('small',[_vm._v(_vm._s(_vm.$t('actions.show_mobile')))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }